import React, { useState } from "react";
import { useRequestProcessor } from "../../../requestProcessor";
import { useAtom } from "jotai";
import { activeChildDetail, CorAtom } from "../../../AtomStore/store";
import { fetchChildCareData } from "../../../QueryFunctions/queryfunction";
import ChildcareDescription from "./ChildcareDescription";
import ListEmptyComponent from "../../../Layout/LoggedInLayout/ListEmptyComponent";

const Childcare1 = () => {
  const { useQueryWrapper } = useRequestProcessor();
  const [activeChild] = useAtom(activeChildDetail);
  const [childCare, setChildcare] = useAtom(CorAtom);
  const [currentChildCareData, setCurrentChildCareData] = useState([]);

  const { isLoading, isFetching } = useQueryWrapper(
    ["childCare", activeChild?.id],
    () => {
      console.log("[Growth] Calling API: /parentapp/childCare ", {
        child_id: activeChild?.id,
      });
      return fetchChildCareData();
    },
    {
      onSuccess: (data) => {
        console.log("[Growth] Childcare response:", data);
        setChildcare(data);
        setCurrentChildCareData(data[0]);
      },
    }
  );
  console.log("childcare", childCare);

  return (
    <div className="max-w-screen-xl mx-auto">
      {isLoading || isFetching ? (
        <div>
          <div className="h-8 w-full bg-header rounded-sm mb-3 p-2 animate-pulse"></div>
          <div className="grid grid-cols-12 gap-4">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((ele) => (
              <div
                className="col-span-12 md:col-span-6  w-full  mx-auto rounded-lg m-3 animate-pulse"
                key={ele}
              >
                <div className="p-3 bg-white shadow-md rounded-lg">
                  <div className="font-semibold h-3 w-40 bg-slate-200 rounded"></div>
                  <div className="h-40 w-full mt-3 bg-slate-200 rounded"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="space-y-6">
          {Array.isArray(childCare) &&
            childCare.map((entry) => (
              <div key={entry.id} className="rounded-lg ">
                <h2 className="text-xl font-bold mb-3 bg-header p-2 pl-4  text-white rounded-sm">
                  {entry.date}
                </h2>
                <ChildcareDescription descriptions={entry.description} />
              </div>
            ))}
        </div>
      )}

      {(!Array.isArray(childCare) ||
        childCare.length === 0 ||
        childCare === undefined) && (
        <div className="flex justify-center items-center my-6">
          <ListEmptyComponent
            heading={isLoading ? "Loading..." : "No Data Found"}
          />
        </div>
      )}
    </div>
  );
};

export default Childcare1;
